<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-07"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <!--  TODO: i18n  -->
        <label slot="title">設備接続先</label>
        <!--  TODO: auth code  -->
        <!--  TODO: i18n  -->
        <sp-smart-button @click="clickCancel" slot="cancel">キャンセル</sp-smart-button>
        <narrow-down @click="clickDone" slot="create">登録</narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
      <loading-dialog :dialog-visible="loading" />
      <div class="panel">
        <div class="row title">
          <ul>
            <li>設備種類</li>
            <li>接続方式<br>（選択）</li>
            <li>参考値表示</li>
            <li>接続先情報<br>（手入力）</li>
          </ul>
        </div>
        <div class="row list1">
          <div>
            <el-form ref="normalForm" v-bind:model="{ devices: normalDevices }">
              <div v-for="(device, index) of normalDevices" :key="device.id" >
                <ul v-if="device.remoteSubType == '0801'">
                  <li>{{displayDeviceType(device.type)}}</li>
                  <li>
                    <el-form-item>
                      <el-select v-model="device.remoteTypeCode">
                        <el-option
                          v-for="option of device.remoteTypeList"
                          :key="option.remoteTypeCode"
                          :value="option.remoteTypeCode"
                          :label="option.remoteTypeName"
                        />
                      </el-select>
                    </el-form-item>
                  </li>
                  <li>
                    <!-- <el-form-item>
                      <el-checkbox v-model="device.showRefValueFlag "/>
                    </el-form-item> -->
                  </li>
                  <li>
                    <el-form-item :prop="`devices.${index}.remoteInfo`" :rules="createConnectionRules(device)">
                      <el-input type="textarea" v-model="device.remoteInfo" :autosize="{ minRows: 4 }" />
                    </el-form-item>
                  </li>
                </ul>

                <!--  NEC QR -->
                <ul v-if="device.remoteSubType == '0803'" class="m-top-38">
                  <li>{{$t("label.device.necQR")}}</li>
                  <li>
                    <el-form-item>
                      <el-select v-model="device.remoteTypeCode">
                        <el-option
                          v-for="option of device.remoteTypeList"
                          :key="option.remoteTypeCode"
                          :value="option.remoteTypeCode"
                          :label="option.remoteTypeName"
                        />
                      </el-select>
                    </el-form-item>
                  </li>
                  <li>

                  </li>
                  <li>
                    <div v-if="(device.remoteInfo != null && device.remoteInfo != '') && (device.remoteTypeCode != null && device.remoteTypeCode != '')">
                      {{$t("label.device.apiKey")}}
                    </div>
                    <div v-if="device.remoteTypeCode != null && device.remoteTypeCode != ''">
                      {{device.remoteInfo}}
                    </div>
                  </li>
                </ul>

                <!-- ビルOS -->
                <ul v-if="device.remoteSubType == '0802'" class="m-top-38">
                  <li>{{$t("label.device.buildOS")}}</li>
                  <li>
                    <el-form-item>
                      <el-select
                        v-model="device.remoteTypeCode"
                        @change="changeBuildOS(device)">
                        <el-option
                          v-for="option of device.remoteTypeList"
                          :key="option.remoteTypeCode"
                          :value="option.remoteTypeCode"
                          :label="option.remoteTypeName"
                        />
                      </el-select>
                    </el-form-item>
                  </li>
                  <li>
                  </li>
                  <li>
                    <el-form-item
                      :prop="`devices.${index}.remoteInfo`"
                      :rules="createConnectionRules(device)">
                      <el-input type="textarea" v-model="device.remoteInfo" :autosize="{ minRows: 4 }" />
                    </el-form-item>
                  </li>
                </ul>
              </div>

            </el-form>
          </div>
        </div>
        <div v-if="sensorDevices.length > 0" class="row list2">
          <p class="margin-bottom-6">環境可視化</p>
          <el-form ref="sensorForm" v-bind:model="{ devices: sensorDevices }">
            <ul v-for="(device, index) of sensorDevices" :key="device.id">
              <li>{{device.categoryName }}</li>
              <li>
                <el-select v-model="device.remoteTypeCode">
                  <el-option
                    v-for="option of remoteTypeOptions"
                    :key="option.code"
                    :value="option.code"
                    :label="option.label"
                  />
                </el-select>
              </li>
              <li>
                  <el-form-item>
                    <el-checkbox v-model="device.showRefValueFlag "/>
                  </el-form-item>
                </li>
              <li>
                <el-form-item :prop="`devices.${index}.remoteInfo`" :rules="createConnectionRules(device)">
                  <el-input type="textarea" v-model="device.remoteInfo" :autosize="{ minRows: 4 }" />
                </el-form-item>
              </li>
            </ul>
          </el-form>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import Menubar from "@/components/leftmenu/DashBoard";
import HeadTitle from "@/components/common/head/head";
import SpSmartButton from "@/components/common/sp-smart-button";
import NarrowDown from "@/components/common/generalButton/NarrowDown";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import api from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";

export default {
  name: "DeviceConnectionList",
  components: { LoadingDialog, MainLayout, Menubar, HeadTitle, NarrowDown, SpSmartButton },
  data() {
    return {
      buildingId: '',
      loading: false,
      remoteTypeOptions: [],
      normalDevices: [],
      sensorDevices: [],
      smartLockRemoteTypeList:[],
      buildOsRemoteTypeList:[],
    }
  },
  created() {
    // TODO: what is bread path?
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "/visual-env/page/search",
        // TODO: i18n
        title: "設備接続先",
      }
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  methods: {
    createConnectionRules(connection) {
      return [
        {
          trigger: ["blur", "change"],
          validator: (rule, value, callback) => {
            if (connection.remoteTypeCode) {
              if (value) {
                let jsonInvalidMsg = this.$t('message.common.validation.type', { field: '接続先情報', type: 'JSON' })
                try {
                  JSON.parse(value);
                  if (value.startsWith('{')) {
                    callback();
                  } else {
                    callback(jsonInvalidMsg);
                  }
                } catch (e) {
                  callback(new Error(jsonInvalidMsg));
                }
              } else {
                callback(new Error("接続先情報を入力してください"));
              }
            } else {
              callback();
            }
          }
        }
      ]
    },

    clickDone() {

      Promise.all([this.$refs.normalForm.validate(), this.sensorDevices !=null && this.sensorDevices.length > 0 && this.$refs.sensorForm.validate()])
        .then(() => {
          this.loading = true;
          const requestConnections = {};
          requestConnections.deviceTypeList = [];
          this.normalDevices.forEach((device) => {
            requestConnections.deviceTypeList.push({
              type: device.type,
              categoryList: [],
              remoteTypeCode: device.remoteTypeCode,
              showRefValueFlag: device.showRefValueFlag ? true : false,
              remoteInfo: device.remoteSubType != '0803' ?  device.remoteInfo : JSON.stringify({'X-API-Key' : device.remoteInfo}) ,
              remoteSubType:device.remoteSubType
            });
          });
          requestConnections.deviceTypeList.push({
            type: '07',
            categoryList: this.sensorDevices.map((device) => {
              return {
                categoryId: device.categoryId,
                remoteTypeCode: device.remoteTypeCode,
                showRefValueFlag: device.showRefValueFlag ? true : false,
                remoteInfo: device.remoteInfo
              }
            }),
            remoteTypeCode: null,
            remoteInfo: null
          });
          api.deviceConnectionUpdate(this.buildingId, requestConnections)
            .then(({ data }) => {
              if (!statusErrorCodeMsg(data.statusCode, this)) {
                return;
              }
              this.$message({
                message: "設備接続先を更新しました",
                type: "success"
              });
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },

    clickCancel() {
      this.$router.push({ name: 'system-building-manage-menu', params: { buildingId: this.buildingId } })
    },

    doneInit() {
      this.buildingId = this.$route.params.buildingId;
      this.loading = true;
      this.remoteTypeOptions = []
      api.deviceConnectionList(this.buildingId)
        .then(({ data }) => {
          const { body } = data;
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }

          this.normalDevices = body.deviceTypeList
            .filter(device => device.type !== '07')
            .map(device => ({
              id: device.type,
              ...device,
              remoteSubType:device.remoteSubType || '0801',
              remoteTypeCode: device.remoteTypeCode || '',
          }));

          this.normalDevices.forEach(device => {
            device.remoteTypeList.unshift({
              remoteTypeCode: '',
              remoteTypeName: 'なし'
            })
          });
          this.normalDevices.sort((a, b) => a.remoteSubType.localeCompare(b.remoteSubType));

          let remoteDevice =  body.deviceTypeList
            .find(device => device.type === '07');
          let remoteTypeList = remoteDevice.remoteTypeList;

          this.sensorDevices = body.deviceTypeList
            .filter(device => device.type === '07')
            .flatMap(device => device.categoryList.map(category => ({
                ownerId: device.ownerId,
                ownerName: device.ownerName,
                ownerExId: device.ownerExId,
                buildingId: device.buildingId,
                buildingName: device.buildingName,
                buildingExId: device.buildingExId,
                type: device.type,
                ...category,
                remoteTypeCode: category.remoteTypeCode || '',
              }))
            )
            .map(device => ({
              id: device.type + device.categoryId,
              ...device
            }));

          this.remoteTypeOptions
          const list = remoteTypeList.map(type => ({
            code: type.remoteTypeCode,
            label: type.remoteTypeName
          }));

          if (list.length > 0) {
            list.forEach((info) => {
              if (info.code == 'default') {
                info.id = 2
              } else if (info.code == 'akerun') {
                info.id = 3
              } else if (info.code == 'suprema') {
                info.id = 4
              } else if (info.code == 'azbil') {
                info.id = 5
              } else if (info.code == 'futaba') {
                info.id = 6
              } else {
                info.id = 7
              }
            })
            list.sort((a, b) => {
              return a.id - b.id
            })
            list.unshift({
              id: 1,
              code: '',
              label: 'なし'
            })
          }
          this.remoteTypeOptions = list

          this.smartLockRemoteTypeList = []
          this.smartLockRemoteTypeList.push({
            remoteTypeCode:null,
            remoteTypeName:'なし'
          })
          if(data.smartLockRemoteTypeList != null && data.smartLockRemoteTypeList.length > 0){
            for(let smartLock of data.smartLockRemoteTypeList){
              this.smartLockRemoteTypeList.push({
                remoteTypeCode:smartLock.remoteTypeCode,
                remoteTypeName:smartLock.remoteTypeName
              })
            }
          }

        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.loading = false;
        });
    },

    displayDeviceType(type) {
      const typeMap = {
        '01': '電子錠',
        '02': 'エレベーター',
        '03': '空調',
        '04': '警備',
        '05': 'スマートロック',
        '07': '環境可視化',
        '08': 'スマートロック'
      }

      return typeMap[type];

      /**
       * 01: 電子錠
       * 02: エレベーター
       * 03: 空調
       * 04: 警備
       * 05: スマートロック
       *
       * 07: 環境可視化
       * 08: スマートロック
       */
    },
    changeBuildOS(device){
      if(device.remoteTypeCode == ''){
        device.remoteInfo = null;
      }
    }
  },

  mounted() {
    this.doneInit();
  }
}
</script>

<style scoped>
.panel .tag-info .input-line {
  display: flex;
}

.panel .tag-info .input-line label {
  width: 120px;
  line-height: 40px;
}

.panel .head {
  margin-left: 0;
  height: 40px;
}
.panel .head .btn {
  float: right;
}
.panel .head .title {
  height: 100%;
  line-height: 40px;
  float: left;
  font-weight: bolder;
}

.panel .tag-list .buttons .btn {
  width: 56px;
  height: 32px;
  padding: initial;
}

.panel .tag-list .tb-input {
  display: inline-block;
  width: 100%;
}

.panel .tag-list .tb-input::v-deep .el-input__inner {
  width: 100% !important;
}

.panel .row ul {
  list-style: none;
  height: initial;
}

.panel .row ul li {
  display: inline-block;
}

.panel .row ul li:nth-child(1) {
  width: 20%;
}

.panel .row ul li:nth-child(2) {
  width: 25%;
}

.panel .row ul li:nth-child(3) {
  width: 15%;
}

.panel .row ul li:nth-child(4) {
  width: 40%;
}

.panel .row.title {
  margin-bottom: 24px;
  border-bottom: 1px solid gray;
}

.panel .row.title ul {
  display: flex;
}

.panel .row ul {
  display: flex;
}

.panel .list2 ul li:nth-child(1) {
  padding-left: 2em;
}

.panel .row::v-deep .el-textarea .el-textarea__inner {
  width: 100% !important;
}
.m-top-38{
  margin-top: 38px;
}
.list1{
  margin-bottom: 70px;
  padding-bottom: 38px;
}
</style>
